const generalTypes = {
	INITIALIZE: {
		START: 'APP_INITIALIZE_START',
		FINISH: 'APP_INITIALIZE_FINISH',
	},
	API_STATUS: {
		LOADING: {
			START: 'API_STATUS_LOADING_START',
			STOP: 'API_STATUS_LOADING_FINISH',
		},
	},
};

export default generalTypes;
